import styles from "./Label.module.css";

const Label = ({ text, className }) => {
  return <div className={`${styles.label} ${className}`}>{text}</div>;
};

export default Label;
